import { ProductArea, type SummaryFilterInput } from "@digits-graphql/frontend/graphql-bearer"
import { molecule, use } from "bunshi/react"
import { atom } from "jotai"
import { LegalEntityIdScope } from "src/frontend/components/LegalEntityIdScope"
import {
  filterCategoriesMolecule,
  filterEntityTypeMolecule,
  filterMinMaxValuesMolecule,
  filterTaxQualificationMolecule,
  filterTermMolecule,
  filterW9StatusMolecule,
} from "src/frontend/components/OS/Applications/VendorDirectory/molecules/filterMolecules"
import { VendorDirectoryScope } from "src/frontend/components/OS/Applications/VendorDirectory/VendorScopeProvider"

/*
  MOLECULES
*/

// filter to be used across filterQueryMolecules
export const summaryFilterVariablesMolecule = molecule(() => {
  // Vendor directory scope does not provide a value that changes, so it just specifies the scope boundary for vendor directory data
  use(VendorDirectoryScope)
  use(LegalEntityIdScope)

  const { selectedCategoriesAtom } = use(filterCategoriesMolecule)
  const { minValueMVAtom, maxValueMVAtom } = use(filterMinMaxValuesMolecule)
  const { selectedW9StatusAtom } = use(filterW9StatusMolecule)
  const { selectedEntityTypeAtom } = use(filterEntityTypeMolecule)
  const { selectedTaxStatusesAtom } = use(filterTaxQualificationMolecule)
  const { filterTermAtom } = use(filterTermMolecule)

  const filterVariablesAtom = atom<Omit<SummaryFilterInput, "viewKey">>((get) => {
    const selectedCategoryIds = Array.from(get(selectedCategoriesAtom)).map(
      ([categoryId, _]) => categoryId
    )
    const selectedW9Status = get(selectedW9StatusAtom)
    const selectedEntityType = get(selectedEntityTypeAtom)
    const selectedTaxStatuses = get(selectedTaxStatusesAtom)

    return {
      productArea: ProductArea.None,
      partyIds: undefined,
      categoryIds: selectedCategoryIds.length > 0 ? selectedCategoryIds : undefined,
      minValue: get(minValueMVAtom),
      maxValue: get(maxValueMVAtom),
      taxpayerIdentifications:
        selectedW9Status && selectedW9Status.size > 0 ? Array.from(selectedW9Status) : undefined,
      partyEntityTypes:
        selectedEntityType && selectedEntityType.size > 0
          ? Array.from(selectedEntityType)
          : undefined,
      taxStatuses:
        selectedTaxStatuses && selectedTaxStatuses.size > 0
          ? Array.from(selectedTaxStatuses)
          : undefined,
      useAbsAmount: true,
      filterTerm: get(filterTermAtom),
    }
  })

  return {
    filterVariablesAtom,
  }
})
